<div class="wrap">

    <div class="margin-large-bottom-res margin-large-top-res">
        <ul class="uk-flex-center" uk-tab>
            <li>
                <a [routerLink]="['/ressource/vehicle/list']">
                    Véhicules
                </a>
            </li>
            <li class="uk-active">
                <a>
                    Stations
                </a>
            </li>
        </ul>
    </div>

    <div class="uk-form-stacked">

        <div class="uk-margin uk-display-inline-block research-form-controls search">
            <div class="uk-form-controls uk-display-inline-block uk-position-relative uk-width-1-1">
                <button class="uk-form-icon uk-form-icon-flip pointer" type="submit" style="border: none; background: inherit;"> 
                    <img src="../../../../assets/icons/Search.svg" width="24px" height="24px" alt="user"/>
                </button>
                <input class="search-bar" type="text" [(ngModel)]="search" (ngModelChange)="onSearchChange($event)" placeholder="Rechercher">
            </div>
        </div>
        
        <button class="button bold button-align uk-display-inline-block uk-float-right uk-margin-left uk-margin-bottom"  *ngIf="session.role.ability === 'super-admin' || session.role.ability === 'admin'" uk-toggle="target: #add-station" type="button">
            <span>Nouvelle station</span>
            <img src="../../../assets/icons/Add.svg" width="32px" height="32px" alt="back" class="uk-margin-left">
        </button>
        
        <button class="button bold button-align uk-display-inline-block uk-float-right uk-margin-bottom" (click)="exportDataAsXLSX()" type="button">
            <span *ngIf="excelLoading === false">
                <span class="vertical-align-middle">Export</span>
                <img src="../../../../assets/icons/Export.svg" width="32px" height="32px" alt="user" class="uk-margin-left"/> 
            </span>
            <span *ngIf="excelLoading === true">
                <div uk-spinner class="loading-small-button"></div>
            </span>
        </button>
        
    </div>

    <div *ngIf="noResult === true" class="bold uk-margin-medium-top">
        Vous n'avez pas de stations.
    </div>

    <div *ngIf="loadingStatus === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loadingStatus === false && noResult === false" class="uk-margin-top">
        <div class="container uk-width-1-1">
            <div uk-grid class="uk-grid-small uk-width-1-1">

                <div *ngFor="let station of stations; let i = index" class="uk-width-1-1">
                    <a href="#" class="uk-card card hover card-border card-list station-card uk-padding-remove color-cold-grey pointer"
                    [routerLink]="['/ressource/station/informations', station.id]" uk-grid style="margin-left: 0px;">

                        <div class="uk-width-2-12 uk-padding-remove img-wrap imgstation">
                            <img [src]="station.photo" onerror="this.src='../../../../assets/img/no-photo.png';this.className='img-error';">
                        </div>

                        <div class="uk-width-10-12" style="padding: 7px 20px 7px 20px;">
                            <span class="uk-card-title light" style="font-size: 32px;">{{ station.name }}</span><br>
                            <span class="light uk-text-uppercase small-offset" style="font-size: 17px;">{{ station.address }}</span><br>
                            <span class="light uk-text-uppercase" style="font-size: 17px;">{{ station.zipCode }} {{ station.city }}</span>
                        </div>

                        <div class="uk-float-right">
                            <img class="uk-position-absolute vertical-align"
                            style="right: 10px;" src="../../../assets/icons/TRIANGLE Right.svg" width="48px" height="48px" alt="user"/>
                        </div>
                    </a>
                </div>

            </div>
        </div>

        <div class="uk-margin-large" *ngIf="maxPages === 0"></div>

        <div class="uk-position-relative uk-width-1-1 uk-padding uk-margin" *ngIf="maxPages > 0">
            <div class="uk-position-center">
                <button [disabled]="currentPage === 1" class="uk-button button" (click)="prevPage()">Précédent</button>
                <div class="uk-display-inline-block" *ngFor="let item of [].constructor(maxPages); let i = index;">
                    <div *ngIf="currentPage === i + 1" class="bold uk-margin-left vop-blue">{{i + 1}}</div>
                    <div *ngIf="currentPage !== i + 1" class="uk-margin-left pointer vop-blue" (click)="goPage(i + 1)">{{i + 1}}</div>
                </div>
                <button [disabled]="currentPage === maxPages" class="uk-button button uk-margin-left" (click)="nextPage()">Suivant</button>
            </div>
        </div>
    </div>

</div>

<app-add-station
    (changed)="updateStations()"
></app-add-station>